import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SalespersonLookupComponent } from '../../Lookup/salesperson-lookup/salesperson-lookup.component';
import { gridPageRequest, tenant, userRolesList } from '../../../model/common/common.model';
import _ from 'lodash';
import { AuthService } from '../../../services/auth.service';
import { AdministratorService } from '../../../services/administrator.service';
import { salesPerson } from '../../../model/masters.model';
import { LoaderComponent } from '../../loader/loader.component';
import { Warehouse } from '../../../model/administration.model';
import { SalesPersonService } from '../../../services/sales-person.service';
import { SharedServiceService } from '../../../services/shared-service.service';
import { InventoryService } from '../../../services/inventory.service';
import { HrmsService } from '../../../services/hrms.service';
import { Employee } from '../../../model/hrms/attendance.model';
import { PurchaseorderService } from '../../../services/purchaseorder.service';
import { PasswordModule } from 'primeng/password';
@Component({
  selector: 'app-user-registration',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent, PasswordModule],
  templateUrl: './user-registration.component.html',
  styleUrl: './user-registration.component.scss'
})
export class UserRegistrationComponent implements OnInit {

  constructor(private salespersonservice: SalesPersonService, private activatedRoute: ActivatedRoute, private router: Router, private messageService: MessageService, public dialogService: DialogService, public ref: DynamicDialogRef, private authService: AuthService, private administratorService: AdministratorService, private sharedService: SharedServiceService, public inventoryService: InventoryService,
    private employeeService: HrmsService, private porderservice: PurchaseorderService
  ) { }

  loader: boolean = false;
  submitted: boolean = false;
  UserId: any = '';
  RoleId: any = '';
  roleList: userRolesList[] = [];
  isEdit: boolean = false;
  showPassword: boolean = false;
  Role: any;
  unitLabel: string = '';
  departmentDropdown: any[] = [];
  filterDepartments: any[] = [];
  DeptLabel: string = '';
  showChangePassword: boolean = false;

  createUserForm = new FormGroup({
    username: new FormControl('', Validators.required),
    firstname: new FormControl('', Validators.required),
    lastname: new FormControl('', Validators.required),
    email: new FormControl('', Validators.email),
    password: new FormControl(''),
    confirmPassword: new FormControl(''),
    confirmNewPassword: new FormControl(''),
    oldPassword: new FormControl(''),
    newPassword: new FormControl(''),
    isactive: new FormControl(true),
    salesperson: new FormControl(''),
    SalespersonId: new FormControl<any>(null),
    SalespersonCode: new FormControl<any>(null),
    userRole: new FormControl('', Validators.required),
    createdby: new FormControl(''),
    warehouse: new FormControl('', Validators.required),
    WarehouseId: new FormControl(),
    WarehouseCode: new FormControl(),
    employee: new FormControl(''),
    employeeId: new FormControl(),
    employeeName: new FormControl(),
    empId: new FormControl(),
    mobile: new FormControl('', [Validators.pattern(/^[0-9]{10}$/)]),
    departments: new FormControl(),
    departmentId: new FormControl('', Validators.required),
    departmentCode: new FormControl(),
    departmentName: new FormControl('', Validators.required),
    department: new FormControl(null, Validators.required),
  })

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  warehouseDropdown: Warehouse[] = [];
  employeeDropdown: Employee[] = [];


  ngOnInit(): void {
    document.title = 'User Registration';
    this.createUserForm.valueChanges.subscribe(() => {
      this.passwordsMatch('password', 'confirmPassword')(this.createUserForm);
      this.passwordsMatch('newPassword', 'confirmNewPassword')(this.createUserForm);
    });
    this.createUserForm.controls.createdby.setValue(localStorage.getItem('username'));
    this.getWarehouse();
    this.getEmployee();
    this.patchuser();
    this.getAllRoless();
    this.getDeptLabel();
    this.getDepartment(this.pageRequest);
    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
    });
  }


  get formControls() {
    return this.createUserForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createUserForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required fields' });
      isValid = false;
    }
    return isValid;
  }

  resetForm() {
    this.createUserForm.reset();
    this.createUserForm.controls.isactive.setValue(true);
    this.createUserForm.controls.createdby.setValue(localStorage.getItem('username'));
    this.submitted = false;
  }

  saveUser(data: any, isEditMode: boolean) {
    this.RoleId = this.createUserForm.controls.userRole.value;
    this.submitted = true;

    if (isEditMode) {
      this.updateUser(data);
    } else {
      this.createUser(data);
    }
  }

  toggleChangePassword(): void {
    this.showChangePassword = !this.showChangePassword;
    const oldPwCtrl = this.createUserForm.controls.oldPassword;
    const newPwCtrl = this.createUserForm.controls.newPassword;
    const confirmPwCtrl = this.createUserForm.controls.confirmNewPassword;

    if (this.showChangePassword) {
      oldPwCtrl.setValidators([Validators.required]);
      newPwCtrl.setValidators([Validators.required, Validators.minLength(6)]);
      confirmPwCtrl.setValidators([Validators.required]);
    } else {
      oldPwCtrl.clearValidators();
      newPwCtrl.clearValidators();
      confirmPwCtrl.clearValidators();
      oldPwCtrl.setValue('');
      newPwCtrl.setValue('');
      confirmPwCtrl.setValue('');
    }
    [oldPwCtrl, newPwCtrl, confirmPwCtrl].forEach(c => c.updateValueAndValidity());
  }

  updateUser(data: any) {
    this.submitted = true;
    data.userId = this.UserId;

    if (!this.isNonPasswordValid()) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required fields' });
      return;
    }

    if (this.showChangePassword) {
      if (!this.formControls.oldPassword.value) {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter your current password.' });
        return;
      }
      if (!this.formControls.newPassword.value) {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a new password.' });
        return;
      }
      if (!this.formControls.confirmNewPassword.value) {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please confirm your new password.' });
        return;
      }
      if (this.formControls.newPassword.value !== this.formControls.confirmNewPassword.value) {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'New passwords do not match.' });
        return;
      }
    }

    data.UpdatedBy = localStorage.getItem('username');
    data.OldPassword = this.showChangePassword ? data.oldPassword : null;
    data.NewPassword = this.showChangePassword ? data.newPassword : null;

    this.loader = true;
    this.administratorService.updateUser(data).subscribe({
      next: () => {
        this.loader = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User Information Updated Successfully.' });
        this.updateRole();
        setTimeout(() => this.router.navigate(['/home/userlist']), 1000);
      },
      error: (error) => {
        this.loader = false;
        const detail = error?.error?.code === 'INVALID_OLD_PASSWORD'
          ? 'Current password is incorrect.'
          : 'Failed to update user.';
        this.messageService.add({ severity: 'error', summary: 'Error', detail });
      }
    });
  }

  createUser(data: any) {
    this.submitted = true;

    if (!this.isNonPasswordValid()) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required fields' });
      return;
    }

    if (!this.formControls.password.value) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a password.' });
      return;
    }

    if (!this.formControls.confirmPassword.value) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please confirm your password.' });
      return;
    }

    if (this.formControls.password.value !== this.formControls.confirmPassword.value) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Passwords do not match.' });
      return;
    }

    if (!this.createUserForm.controls.email.value) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please Enter Email.' });
      return;
    }

    if (!this.RoleId) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please Select Role.' });
      return;
    }

    const { confirmPassword, confirmNewPassword, ...payload } = this.createUserForm.value;

    this.loader = true;
    this.authService.createuser(payload).subscribe({
      next: (data: any) => {
        if (data.success) {
          this.UserId = data.userId;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User Created Successfully.' });
          this.createRole();
          this.resetForm();
          this.loader = false;
          setTimeout(() => {
            this.router.navigate(['/home/userlist']);
          }, 1000);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Warning', detail: data.message });
          this.createUserForm.controls.username.setValue('');
          this.loader = false;
        }
      },
      error: error => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create user.' });
        this.loader = false;
      }
    });
  }

  createRole() {
    let createdBy = this.createUserForm.controls.createdby.value;
    this.loader = true;
    this.authService.createuserRole(this.UserId, this.RoleId.roleId, createdBy).subscribe({
      next: data => {
        this.loader = false;
      },
      error: error => {
        this.loader = false;
        console.log(error);
      }
    })
  }

  updateRole() {
    const updatedBy = localStorage.getItem('username');
    if (!updatedBy) {
      console.error('No username found in localStorage');
      return;
    }

    this.createUserForm.controls.createdby.setValue(updatedBy);

    this.loader = true;
    this.Role.UserId = this.UserId;
    this.Role.roleId = this.RoleId;

    this.authService.updateuserRole(this.Role).subscribe({
      next: data => {
        this.loader = false;
        this.sharedService.triggerMenuRefresh();
        console.log('Role updated successfully', data);
      },
      error: error => {
        this.loader = false;
        console.error('Error updating role', error);
      }
    });
  }




  getSalesperson() {
    this.ref = this.dialogService.open(SalespersonLookupComponent, {
      header: 'Salesperson List',
      width: '60%',

    });
    this.ref.onClose.subscribe((data: salesPerson) => {
      if (data) {
        let salesperson = data.salespersonCode + " - " + data.salespersonName;
        this.createUserForm.controls.salesperson.setValue(salesperson);
        this.createUserForm.controls.SalespersonCode.setValue(data.salespersonCode);
        this.createUserForm.controls.SalespersonId.setValue(_.toString(data.salespersonId));
      }
    });
  }


  getAllRoless() {
    this.administratorService.getAllRoles().subscribe({
      next: data => {
        this.roleList = data as userRolesList[];
      },
      error: error => {
        console.log(error);
      }
    })
  }

  setUserRole(data: any) {
    this.RoleId = data.value.roleId;
  }


  getAllRoles(roleId: number): void {
    this.administratorService.getAllRoles().subscribe({
      next: (rolesData: any[]) => {
        const role = rolesData.find(r => r.roleId === roleId);
        if (role) {
          this.createUserForm.patchValue({
            userRole: role
          });
        }
        this.Role = role;
      },
      error: (error: any) => {
        console.error('Error fetching roles data:', error);
      }
    });
  }


  getUserRoleById(userRoleId: number): void {
    this.administratorService.getUserRoleById(userRoleId).subscribe({
      next: (roleData: any) => {
        if (roleData) {
          this.RoleId = roleData.roleId;
          this.getAllRoles(roleData.roleId);
        }
      },
      error: (error: any) => {
        console.error('Error fetching user role data:', error);
      }
    });
  }

  getWarehouse() {
    this.administratorService.getAllWarehouse(this.pageRequest).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  setWarehouse(data: any) {
    if (data.value) {
      this.createUserForm.controls.WarehouseId.setValue(_.toString(data.value.warehouseId));
      this.createUserForm.controls.WarehouseCode.setValue(data.value.warehouseName);
    }
  }

  cancel() {
    this.router.navigate(['/home/userlist'])
  }

  patchuser(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.UserId = params['userId'];
      this.isEdit = !!this.UserId;

      this.createUserForm.controls.confirmPassword.setValidators(!this.isEdit ? [Validators.required] : []);
      this.createUserForm.controls.confirmPassword.updateValueAndValidity();

      if (this.isEdit) {
        this.administratorService.getUserById(this.UserId).subscribe({
          next: (userData: any) => {
            if (userData) {
              this.createUserForm.patchValue({
                username: userData.username,
                firstname: userData.firstName,
                lastname: userData.lastName,
                email: userData.email,
                isactive: userData.isActive,
                SalespersonId: userData.salespersonId,
                SalespersonCode: userData.salespersonCode,
                createdby: userData.createdBy,
                WarehouseCode: userData.warehouseCode,
                WarehouseId: userData.warehouseId,
                warehouse: userData.warehouseCode,
                employeeId: userData.employeeId,
                empId: userData.empId,
                employeeName: userData.employeeName,
                employee: userData.employeeId + ' - ' + userData.employeeName,
                mobile: userData.mobile,
                department: userData.department,
                departmentName: userData.department.departmentName,
                departmentId: userData.department.departmentId,
                departmentCode: userData.department.departmentCode,
              });

              this.createUserForm.controls.password.clearValidators();
              this.createUserForm.controls.password.updateValueAndValidity();

              if (userData.salespersonId) {
                this.getSalespersonById(userData.salespersonId);
              }

              if (userData.userId) {
                this.getUserRoleById(userData.userId);
              }
            }
          },
          error: (error: any) => {
            console.error('Error fetching user Information data:', error);
          }
        });
      }
    });
  }


  passwordsMatch(passwordControl: string, confirmControl: string) {
    return (form: FormGroup) => {
      const pass = form.get(passwordControl)?.value;
      const confirm = form.get(confirmControl)?.value;

      if (!confirm) {
        // nothing typed yet — don't flag mismatch, let 'required' (if any) own this state
        const errors = form.get(confirmControl)?.errors;
        if (errors) {
          delete errors['mismatch'];
          form.get(confirmControl)?.setErrors(Object.keys(errors).length ? errors : null);
        }
        return;
      }

      if (pass !== confirm) {
        form.get(confirmControl)?.setErrors({ mismatch: true });
      } else {
        const errors = form.get(confirmControl)?.errors;
        if (errors) {
          delete errors['mismatch'];
          form.get(confirmControl)?.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    };
  }

  private isNonPasswordValid(): boolean {
    const passwordFields = ['password', 'confirmPassword', 'oldPassword', 'newPassword', 'confirmNewPassword'];
    return Object.keys(this.createUserForm.controls)
      .filter(key => !passwordFields.includes(key))
      .every(key => this.createUserForm.get(key)?.valid);
  }


  getSalespersonById(salespersonId: number): void {
    this.salespersonservice.getSalespersonById(salespersonId).subscribe({
      next: (salespersonData: any) => {
        if (salespersonData) {
          const salesperson = `${salespersonId} - ${salespersonData.salespersonName}`;
          this.createUserForm.patchValue({
            salesperson: salesperson
          });
        } else {
          this.createUserForm.patchValue({
            salesperson: salespersonId.toString()
          });
        }
      },
      error: error => {
        console.error('Error fetching salesperson data:', error);
      }
    });
  }


  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  // employee

  getEmployee() {
    this.employeeService.getEmployees(this.pageRequest).subscribe({
      next: (data: any) => {
        this.employeeDropdown = data.employees.map((emp: { employeeId: any; firstName: any; lastName: any; }) => ({
          ...emp,
          displayName: `${emp.employeeId} - ${emp.firstName} ${emp.lastName}`
        }));
      },
      error: error => {
        console.log(error);
      }
    });
  }



  setEmployees(event: any) {
    if (event) {
      const emp = event;
      this.createUserForm.controls.employeeId.setValue(emp.value.employeeId);
      this.createUserForm.controls.empId.setValue(emp.value.empId);
      this.createUserForm.controls.employeeName.setValue(emp.value.firstName + ' ' + emp.value.lastName);
    }
  }

  filterDepartment(event: any) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < (this.departmentDropdown as any[]).length; i++) {
      let departments = (this.departmentDropdown as any[])[i];
      if (departments.departmentCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        departments.departmentName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(departments);
      }
    }
    this.filterDepartments = filtered;
  }

  SelectedDepartment(event: any) {
    if (event && event.value) {
      const SelectedDepartment = event.value;
      this.createUserForm.controls['departmentCode'].setValue(SelectedDepartment.departmentCode);
      this.createUserForm.controls['departmentId'].setValue(SelectedDepartment.departmentId);
      this.createUserForm.controls['departmentName'].setValue(SelectedDepartment.departmentName);
    }
  }

  getDeptLabel(): void {
    this.loader = true;
    const appKey = 'DeptLabel';

    this.inventoryService.getDeptByAppKey(appKey).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response?.appKeycode === appKey) {
          this.DeptLabel = response?.data;
        } else {
          this.DeptLabel = 'Department';
        }
      },
      error: error => {
        console.error('Error fetching Department Label:', error);
        this.DeptLabel = 'Department';
        this.loader = false;
      }
    });
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  getDepartment(query: gridPageRequest) {
    this.porderservice.getDepartment(query).subscribe({
      next: (data: any) => {
        this.departmentDropdown = data.department;
        if (data.department) {
          this.createUserForm.controls['departmentCode'].setValue(data.department[0].departmentCode);
          this.createUserForm.controls['departmentId'].setValue(data.department[0].departmentId);
          this.createUserForm.controls['departmentName'].setValue(data.department[0].departmentName);
        }
      }
    });
  }


}
